<!-- open wrapper   -->
<!-- <div> -->
<div class="titleblock">
		<a data-toggle="collapse" [attr.data-target]="'#' + sezione.nomeCampoId" aria-expanded="false" aria-controls="panelcontenttemplate" class="collapsed">
	<h3 class="title1level">Documentazione allegata {{ sezione.isMain
		? 'Fascicolo' : sezione.nomeSezione }}</h3></a>
	<p *ngIf="writable">
		<a href="javascript:void(0)" (click)="showAddDocModal(sezione.nomeCampoId)">Aggiungi
			documento<span class="glyphicon glyphicon-plus-sign"></span>
		</a>
	</p>
</div>
<div class="container_dati_generali">
	<ul id="{{sezione.nomeCampoId}}" class="collapse" documenti_allegati_lista="" [documenti]="sezione.documenti" [writable]="sezione.writable" [nomeCampoId]="sezione.nomeCampoId"
		[subdoc]="true" [fascicolo]="fascicolo"
		(onReturn)="onReturnUpdateCallback(sezione)"
		(openModal)="showUploadNewVersionModal($event)"
		(openHistoryModal)="showHistoryModal($event)"
		(removDoc)="removeDoc($event)"
		(onOpenUpdateMetadatiModal)="showUpdateMetadatiModal($event)"></ul>
</div>
<!-- close wrapper   -->
